import { isLatinoChannel } from '@/utils/common/latino-app';

/** DataGrail embed consent-loader (pairs with GTM per channel/env in channel customize variables). */
const DATAGRAIL_CONSENT_BASE = 'https://api.consentjs.datagrail.io/e0e1568a-2ef6-4022-8f3d-487fd487e34f';

const DATAGRAIL_CONSENT_APP_IDS = {
  /** tb1.sayweee.net — GTM-596KDHX */
  weeeTest: '4c100f5d-8601-4c72-acba-b13f9c431508',
  /** www.sayweee.com — GTM-KTQGLRG */
  weeeProd: '32b4f34e-d5b4-4dc6-8660-982bf950b25c',
  /** www.masgusto.com — GTM-T3WJBLJ3 */
  masgustoProd: '0a6e0052-439a-4e4d-a019-2766a80c7371',
  /** tb1.masgusto.net — GTM-M795JTGD */
  masgustoTest: 'e57121a0-6df3-431d-bd31-b543da82128e'
} as const;

export const getDatagrailConsentLoaderSrc = (isLatino: boolean) => {
  const isProd = (process.env.ENV_VAR || process.env.NEXT_PUBLIC_ENV_VAR) === 'prod';
  const appId = isLatino
    ? isProd
      ? DATAGRAIL_CONSENT_APP_IDS.masgustoProd
      : DATAGRAIL_CONSENT_APP_IDS.masgustoTest
    : isProd
      ? DATAGRAIL_CONSENT_APP_IDS.weeeProd
      : DATAGRAIL_CONSENT_APP_IDS.weeeTest;

  return `${DATAGRAIL_CONSENT_BASE}/${appId}/consent-loader.js`;
};

/** Current channel’s consent-loader URL (Weee vs MasGusto). */
export const getCurrentDatagrailConsentLoaderSrc = () => getDatagrailConsentLoaderSrc(isLatinoChannel());

export const DATAGRAIL_PRIVACY_CHOICES_LAYER_ID = 'categories-layer';
export const DATAGRAIL_BANNER_API_POLL_MS = 300;
export const DATAGRAIL_BANNER_API_MAX_WAIT_MS = 15000;
